import BaseModalPopup from "./BaseModalPopup.vue";

export default BaseModalPopup;
